import { render, staticRenderFns } from "./calendar-sidebar.vue?vue&type=template&id=142d6fc8&scoped=true&"
import script from "./calendar-sidebar.vue?vue&type=script&lang=ts&"
export * from "./calendar-sidebar.vue?vue&type=script&lang=ts&"
import style0 from "./calendar-sidebar.vue?vue&type=style&index=0&id=142d6fc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142d6fc8",
  null
  
)

export default component.exports